import axios from "axios";
import {makeOnReject, onFullFilled} from "../../Services/BookingkitApi/Interceptors";
import {InventoryService} from "../../Services/BookingkitApi";
import {DefaultApi} from "@bookingkit/api-v4";
import {WIDGET_API_V4_BASE_URL} from "../../Constants/environment";
import {WidgetService} from "../../Services/BookingkitApi/WidgetService";

export default ({logger, widgetId}: { logger:ILogger, widgetId: string }) => {
    const axiosInstance = axios.create({});
    axiosInstance.interceptors.response.use(onFullFilled, makeOnReject(logger));
    return {
        experienceService : new InventoryService(
            widgetId,
            new DefaultApi(undefined,
                WIDGET_API_V4_BASE_URL,
                // @ts-ignore
                axiosInstance
            )),
        widgetService : new WidgetService(
            widgetId,
        new DefaultApi(undefined,
            WIDGET_API_V4_BASE_URL,
            // @ts-ignore
            axiosInstance
        )),
    }
}
